import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  public productsUrl = 'https://arike.malonglobaltech.com/api/products'

  constructor(
    public http: HttpClient
  ) { }

  // async getProduct(id){
  //   return this.afs.collection('fashion_products').doc(id)
  // }

  // async getProductsByGender(){
  //   return this.afs.collection('fashion_products', ref=>ref.limit(9))
  // }

  // async getAllProducts(){
  //   return this.afs.collection('fashion_products', ref=> ref.where('availability', '==', 'true'))
  // }

  // async getFeaturedProducts(){
  //   return this.afs.collection('fashion_products', ref=> ref.where('availability', '==', 'true').where('best_selling', '==', true).limit(9))
  // }

  // async getAllProductsInAcategory(id){
  //   return this.afs.collection('fashion_products' , ref=> ref.where('parent_category_id', '==', id))
  // }

  async getAllProducts (){
    const token = await JSON.parse(localStorage.getItem('token'))
    return await this.http.get(this.productsUrl, {
      headers: new HttpHeaders({        
          'Content-Type':  'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${token}`
        })
    }) 
  }

  async getProduct (id){
    const token = await JSON.parse(localStorage.getItem('token'))
    const url = await this.productsUrl+'/'+id
    return await this.http.get(url, {
      headers: new HttpHeaders({        
          'Content-Type':  'application/json',
          'Accept': 'application/json',
          Authorization: `Bearer ${token}`
        })
    }) 
  }
}
